import { HippocampusAPI } from "./HcgApi";
import { SteamAPI } from "./SteamApi";
import { SocialAPI } from "./SocialApi";
import { AchievementsAPI } from "./AchievementsApi";
import { GamesAPI } from "./GamesApi";
import { MessagingAPI } from "./MessagingApi";
import { NotificationsAPI } from "./NotificationsApi";
import { LfgAPI } from "./LfgApi";
import { LobbyAPI } from "./LobbyApi";
// import { PSNAPI } from "./PSNAPI";

export const api = {
  app: new HippocampusAPI(),
  steam: new SteamAPI(),
  social: new SocialAPI(),
  achievements: new AchievementsAPI(),
  games: new GamesAPI(),
  messaging: new MessagingAPI(),
  notifications: new NotificationsAPI(),
  lfg: new LfgAPI(),
  lobby: new LobbyAPI(),
//   psn: new PSNAPI(),
};